import { useI18n } from "@/i18n/I18nContext";

// Par défaut deux langues (application interne) ; les pages publiques
// passent langues={["en", "fr", "es"]}.
export default function LangSwitch({ className = "", langues = ["en", "fr"] }) {
  const { lang, setLang } = useI18n();
  return (
    <div className={`inline-flex items-center rounded-md border border-line-strong overflow-hidden ${className}`} data-testid="lang-switch">
      {langues.map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => setLang(l)}
          className={`px-2.5 py-1 text-xs font-bold uppercase tracking-wider transition-colors ${
            lang === l ? "bg-orange-600 text-white" : "text-ink-soft hover:bg-hover-strong hover:text-ink"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
